import React, { Fragment } from "react";
import { useState, useEffect } from "react";
import {useDispatch, useSelector} from 'react-redux';
import { removeFromCart } from "../../redux/actions/cartAndWishlistActions";


const CartPage = () => {

    const dispatch = useDispatch()

    let {cartItem}  = useSelector((state) => state.addToCart)

      let objLength = Object.getOwnPropertyNames(cartItem).length;
      let {name, id, price, sprites} = cartItem;

    const handleDeleteItem = (id) => {  
         dispatch(removeFromCart(id));
    }

    const handleBuyPokemon =(id) =>{
        // push item to cart
    }

    useEffect(() => {
         
      }, [dispatch])

    return (
                <div className="CartWrapper">
                        <div className="wishListItemsBox">
                            <>
                                {

                                 objLength && objLength? (

                                    <div className="wishListsItem" >
                                    <div className="wishListsImage">
                                        <div className="wishlistImage">
                                            <img
                                             src={sprites.front_default}
                                            />
                                        </div>
                                    </div>
                                    <div className="wishListsName">
                                        <span className="pokemonNameKey">
                                           Pokemon Name: <span className="pokemonNameVal">{name}</span>
                                        </span>
                                    </div>   
                                    <div className="wishListsPrice">
                                       <span className="pokemonNameKey">
                                           Price: <span className="pokemonNameVal">{price}</span>
                                        </span>                                                   
                                     </div>
                                    <div className="wishListsDelete">
                                       <button className="btnDelete"
                                            onClick={() => handleDeleteItem(id)}
                                       >                                                             
                                            <span className="btnDeleteIcon"> Remove</span>from cart
                                       </button> 
                                    </div>
                                    <div className="wishListsDelete">
                                       <button className="btnDelete"
                                            // onClick={() => handleDeleteItem(poke.id)}
                                       >                                                             
                                            <span className="btnDeleteIcon"> buy</span>and deploy
                                       </button> 
                                    </div>
                                </div>

                                   ): 
                                    (
                                        <div className="wishListisEmpty">
                                        <div><h1 className="wishListEmptyh1">Your Pokemon basket is Empty</h1></div>
                                        <div>
                                            <a href="/wishlists">
                                                <button className="wishListEmptyBtn">to purchase a pokemon
                                                        <span className="wishListEmptySpan">add your favourite to the wishlist and continue to buy</span>
                                                </button>
                                            </a>
                                            </div>
                                        </div>
                                    )
                                }

                            </>
                                
                    </div>
                </div>
    )
}

export default CartPage;
       